/*
DomQuery Module
List of functions to read browser and dom element properties cross browser consistently
*/
define(function () {

    'use strict';

    var domQ;

    (function() {
        domQ = function(el) {

            if (typeof el === 'string') {
                return new DomQuery(document.createElement(el));
            }

            return new DomQuery(el);
        };

        var DomQuery = function(el) {
            this.el = el;
            return this;
        };

        DomQuery.prototype = {

            /**
             * Returns offset of domQ element 
             * @returns {Object} offset object
             */
            offset: function() {
                var curleft = 0,
                    curtop = 0;

                if (this.el.offsetParent) {
                    do {
                        curleft += this.el.offsetLeft;
                        curtop += this.el.offsetTop;

                        this.el = this.el.offsetParent;
                    } while (this.el);
                }

                return {left: curleft, top: curtop};
            },

            /**
             * Returns width of domQ element 
             * @returns {Number} element width
             */
            width: function () {

                if (!window.addEventListener) {
                    return 0;
                }

                var elStyle = window.getComputedStyle(this.el),
                    width = elStyle.width === 'auto' ? this.el.offsetWidth : parseFloat(elStyle.width);

                if (this.browser.ie) {
                    width += (parseFloat(elStyle.paddingRight) + parseFloat(elStyle.paddingRight));
                }

                return width;
            },

            /**
             * Returns height of domQ element 
             * @returns {Number} element height
             */
            height: function() {

                if (!window.addEventListener) {
                    return 0;
                }

                var elStyle = window.getComputedStyle(this.el),
                    height = elStyle.height === 'auto' ? this.el.offsetHeight : parseFloat(elStyle.height, 10);

                if (this.browser.ie) {
                    height += (parseFloat(elStyle.paddingTop) + parseFloat(elStyle.paddingBottom));
                }

                return height;
            },

            /**
             * Add css class to domQ element
             * @param {string} css class name 
             * @returns {Object} DomQuery instance
             */
            addClass: function(cssClass) {
                var list = this.el.className.split(/\s+/);

                if (list.indexOf(cssClass) > -1) {
                    return;
                }

                list.push(cssClass);
                this.el.className = list.join(' ');

                return this;
            },

            /**
             * Remove css class from domQ element
             * @param {string} css class name 
             * @returns {Object} DomQuery instance
             */
            removeClass: function(cssClass) {
                var list = this.el.className.split(/\s+/);

                if (list.indexOf(cssClass) === -1) {
                    return;
                }

                list = list.filter(function(item) {
                    return item !== cssClass;
                });

                this.el.className = list.join(' ');

                return this;
            },

            /**
             * Check if domQ element has a css class
             * @param {string} css class name 
             * @returns {Boolean} true if element has specified css class
             */
            hasClass: function(cssClass) {
                return this.el.className.split(/\s+/).indexOf(cssClass) !== -1;
            },

            /**
             * Set attribute to element
             * @param {string} attribute name
             * @param {string} attribute value 
             * @returns {Object} DomQuery instance
             */
            attr: function(name, value) {
                if (value) {
                    this.el.setAttribute(name, value);
                    return this;
                }

                return this.el.getAttribute(name);
            },

            /**
             * Set text to element
             * @param {string} text content
             * @returns {Object} DomQuery instance
             */
            text: function(text) {
                if (text) {
                    this.el.textContent = text;
                    return this;
                }

                return this.el.textContent;
            },

            /**
             * Set html content to element
             * @param {string} html content
             * @returns {Object} DomQuery instance
             */
            html: function(html) {
                if (html) {
                    this.el.innerHTML = html;
                    return this;
                }

                return this.el.innerHTML;
            },

            /**
             * Appends current element into provided element
             * @param {Object} DOM element
             * @returns {Object} DomQuery instance
             */
            appendTo: function(el) {
                el.appendChild(this.el);
                return this;
            },

            /**
             * Appends provided element into current element
             * @param {Object} DOM element
             * @returns {Object} DomQuery instance
             */
            append: function(el) {
                if (el instanceof Element) {
                    this.el.appendChild(el);
                }

                return this;
            }
        };

        // set browser configurations
        (function(){
            var isIE = function () {
                    return ((navigator.appName == 'Microsoft Internet Explorer')
                        || ((navigator.appName == 'Netscape')
                        && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) != null)));
                };
            DomQuery.prototype.browser = {
                ie: isIE()
            };
        })();

    }());

    return domQ;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/lib/domQ.js